
export function renderCausal () {
    return(
  <div className="text-slate-900 dark:text-white transition-colors duration-300">
      <main className="py-10 ransition-colors duration-300">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400 mb-6 font-mono">
            <span>Platform</span>
            <span className="material-symbols-outlined text-[10px]">chevron_right</span>
            <span>Netraa AIOPs</span>
            <span className="material-symbols-outlined text-[10px]">chevron_right</span>
            <span className="text-primary font-bold">Causal AI for True RCA</span>
          </div>

          {/* Hero Section */}
           <section className="mb-16 relative group scroll-mt-24" id="causal-hero">
  <div className="absolute -inset-1 opacity-10 transition duration-1000 group-hover:opacity-20" />

  <div className="relative rounded-2xl overflow-hidden transition-colors duration-300">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center relative z-10">
      
      {/* LEFT CONTENT */}
      <div className="space-y-6 px-2">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ff6a3d]/10 border border-[#ff6a3d]/30 text-[#ff6a3d] text-xs font-bold uppercase tracking-wider">
          <span className="size-2 rounded-full bg-[#ff6a3d] animate-pulse" />
          New Feature
        </div>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          True Causal AI:
          <span className="block text-slate-900 dark:text-white">
            The End of the Correlation Game
          </span>
        </h1>

        <p className="text-base sm:text-lg text-slate-700 dark:text-slate-300 leading-relaxed font-medium">
          Mirror human reasoning. Netraa constructs a precise diagnostic chain
          that identifies the single primary root cause, not just symptoms.
        </p>
      </div>

      {/* RIGHT VISUAL */}
      <div
        className="relative w-full max-w-sm mx-auto lg:mx-0 h-64 sm:h-72 lg:h-80 rounded-lg 
        bg-white dark:bg-[#080c14] border border-slate-200 dark:border-slate-800 
        flex items-center justify-center overflow-hidden transition-colors duration-300 shadow-lg"
        style={{ backgroundImage: "radial-gradient(circle at 50% 50%, rgba(255,200,150,0.1) 0%, rgba(255,255,255,0) 80%)" }}
      >
                  {/* Grid overlay */}
                  <div
                    className="absolute inset-0 opacity-10 dark:opacity-20"
                    style={{
                      backgroundImage:
                        "linear-gradient(var(--tw-text-opacity, #cbd5e1) 1px, transparent 1px), linear-gradient(90deg, var(--tw-text-opacity, #cbd5e1) 1px, transparent 1px)",
                      backgroundSize: "20px 20px",
                    }}
                  />

                  {/* Floating nodes */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="absolute top-1/4 left-1/4 size-3 rounded-full bg-orange-300 shadow-md" />
                    <div className="absolute bottom-1/3 right-1/4 size-3 rounded-full bg-red-300 shadow-md" />

                    {/* Path SVG */}
                    <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 100 100">
                      <path
                        className="path-flow drop-shadow-[0_0_5px_rgba(255,145,77,0.6)]"
                        d="M10,80 Q30,70 40,50 T80,30"
                        fill="none"
                        stroke="url(#gradient-path)"
                        strokeWidth="1.2"
                      />
                      <defs>
                        <linearGradient id="gradient-path" x1="0%" x2="100%" y1="0%" y2="0%">
                          <stop offset="0%" style={{ stopColor: "#FF914D", stopOpacity: 1 }} />
                          <stop offset="100%" style={{ stopColor: "#FF3131", stopOpacity: 1 }} />
                        </linearGradient>
                      </defs>
                    </svg>

                    {/* Root Cause Highlight */}
                    <div className="absolute top-[30%] left-[80%] transform -translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform">
                      <div className="size-6 rounded-full bg-orange-400 shadow-[0_0_20px_rgba(255,77,49,0.5)] animate-pulse border-2 border-white dark:border-black" />
                      <div className="absolute top-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] font-mono text-secondary font-bold bg-white dark:bg-black px-2 py-0.5 rounded border border-secondary/30 shadow-sm">
                        ROOT CAUSE
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

            <section className="mb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center scroll-mt-24" id="correlation-problem">
              <div className="order-2 lg:order-1">
                <div className="relative aspect-square max-h-[400px] rounded-xl bg-slate-50 dark:bg-[#10131a] border border-slate-200 dark:border-red-900/30 p-6 flex items-center justify-center overflow-hidden group transition-colors duration-300 shadow-inner">
                  <div className="absolute inset-0 opacity-10 dark:opacity-30 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-500/20 via-transparent to-transparent" />
                  <div className="relative z-10 flex flex-col items-center gap-4" data-alt="Iconography representing an alert storm.">
                    <div className="size-16 rounded-full bg-white dark:bg-[#1c1414] border border-red-500/50 flex items-center justify-center mb-4 shadow-lg">
                      <span className="material-symbols-outlined text-secondary text-3xl">hub</span>
                    </div>
                    <svg className="absolute top-10 left-1/2 -translate-x-1/2 opacity-60 dark:opacity-80" height="150" viewBox="0 0 200 150" width="200">
                      <path d="M100,20 Q150,50 180,20" fill="none" stroke="#FF3131" strokeWidth="1"></path>
                      <path d="M100,20 Q50,80 20,40" fill="none" stroke="#FF3131" strokeWidth="1"></path>
                      <path d="M100,20 Q120,100 80,130" fill="none" stroke="#FF3131" strokeWidth="1"></path>
                      <path d="M100,20 Q80,60 140,90" fill="none" stroke="#FF3131" strokeWidth="1"></path>
                      <path d="M100,20 Q180,100 160,140" fill="none" stroke="#FF3131" strokeWidth="1"></path>
                    </svg>
                    <div className="bg-red-50 dark:bg-red-950/80 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-200 text-xs px-3 py-1 rounded font-mono shadow-sm">⚠ 432 ALERTS TRIGGERED</div>
                  </div>
                </div>
              </div>

              <div className="order-1 lg:order-2 space-y-6">
                <h2 className="text-3xl font-bold text-slate-900 dark:text-white font-display transition-colors">The Problem: <span className="text-secondary">Correlation is Not Causation</span></h2>
                <div className="h-1 w-20 bg-gradient-netraa rounded-full" />
                <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed transition-colors">Most platforms rely on basic correlation, leading to alert storms. Even leading competitors send teams chasing misleading symptoms instead of fixing the actual fire.</p>
                <ul className="space-y-3 mt-4">
                  <li className="flex items-start gap-3 text-slate-700 dark:text-slate-300 transition-colors"><span className="material-symbols-outlined text-secondary shrink-0 mt-0.5">close</span><span>Wasted engineering hours investigating ghosts.</span></li>
                  <li className="flex items-start gap-3 text-slate-700 dark:text-slate-300 transition-colors"><span className="material-symbols-outlined text-secondary shrink-0 mt-0.5">close</span><span>MTTR balloons as teams fight symptoms.</span></li>
                </ul>
              </div>
            </section>

            <section className="mb-20 scroll-mt-24" id="precision-solution">
  <div className="text-center mx-auto mb-12">
    <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4 font-display transition-colors">
      The Solution: Distinguishing Signal from Noise
    </h2>
    <p className="text-slate-600 dark:text-slate-400 transition-colors">
      Netraa's 3-stage precision engine cuts through the noise to find the truth.
    </p>
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

    {/* CARD STYLE BASE (same for all) */}
    {[
      {
        num: "01",
        icon: "filter_list",
        title: "Holistic Data Ingestion",
        desc: "Ingesting Metrics, Logs, Traces, and Change Events into a unified funnel.",
        footer: (
          <div className="flex gap-2 opacity-50 grayscale group-hover:grayscale-0 transition-all duration-500">
            <span className="material-symbols-outlined text-blue-500 text-sm">terminal</span>
            <span className="material-symbols-outlined text-purple-500 text-sm">bar_chart</span>
            <span className="material-symbols-outlined text-green-500 text-sm">timeline</span>
          </div>
        ),
      },
      {
        num: "02",
        icon: "memory",
        title: "Intelligent Distinction Engine",
        desc: "AI sieve separates input into downstream failures, secondary symptoms, and the primary path.",
        footer: (
          <div className="h-2 w-full flex rounded-full overflow-hidden">
            <div className="w-1/4 bg-slate-300 dark:bg-slate-800" />
            <div className="w-1/4 bg-slate-400 dark:bg-slate-700" />
            <div className="w-2/4 bg-slate-500 dark:bg-slate-600" />
          </div>
        ),
      },
      {
        num: "03",
        icon: "gps_fixed",
        title: "Root Cause ID",
        desc: "The causal path hits the glowing target, revealing the exact failed component.",
        footer: (
          <div className="flex items-center gap-2 text-xs font-mono font-bold text-slate-700 dark:text-slate-300">
            <span className="material-symbols-outlined text-sm">check_circle</span>
            <span>PAYMENT_SVC_V2</span>
          </div>
        ),
      },
    ].map((card, i) => (
      <div
        key={i}
        className="
          bg-white dark:bg-[#0f1621]
          border border-slate-200 dark:border-slate-800
          rounded-xl p-6 relative overflow-hidden
          group hover:border-slate-400 dark:hover:border-slate-600
          transition-all shadow-sm
        "
      >
        {/* Top Accent Bar (same color for all) */}
        <div className="absolute top-0 left-0 w-full h-1 bg-slate-400 dark:bg-slate-700" />

        <div className="mb-6 flex justify-between items-start">
<span className="text-4xl font-black text-slate-300 dark:text-slate-700 font-display">
            {card.num}
          </span>

          <div className="p-3 bg-slate-100 dark:bg-slate-800/50 rounded-lg">
            <span className="material-symbols-outlined text-slate-500 dark:text-slate-400">
              {card.icon}
            </span>
          </div>
        </div>

        <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 transition-colors">
          {card.title}
        </h3>

        <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 transition-colors">
          {card.desc}
        </p>

        {card.footer}
      </div>
    ))}

  </div>
</section>

            <div className="mt-16 rounded-2xl bg-gradient-to-br from-[#121c2d] to-[#0a0f16] border border-slate-800 p-6 sm:p-8 lg:p-10 text-center relative overflow-hidden shadow-2xl">
              <div className="absolute top-0 right-0 p-12 opacity-10 pointer-events-none"><span className="material-symbols-outlined text-9xl text-white">rocket_launch</span></div>
              <div className="absolute inset-0 bg-gradient-netraa opacity-5" />
              <h2 className="text-2xl font-bold text-white mb-3 relative z-10 font-display">Stop chasing symptoms. Start fixing causes.</h2>
              <p className="text-slate-400 mb-8 max-w-lg mx-auto relative z-10">Reduce MTTR by 80% with Netraa's Causal AI engine.</p>
                </div>
        </main>
      </div>
    );
}